import { Button, Box } from '@rsos/base-components';
import { GPXFeature } from '@rsos/gainsight';
import { LiveVideoButtonContainer } from '../VideoTo911/LiveVideoButtonContainer';
import TF911EndChat from './TF911EndChat';
import TF911StartChatAccordion from './TF911StartChatAccordion';

interface TF911ChatHeaderButtonsProps {
  isFetchingMetadata: boolean;
  showStartChat: boolean;
  isCreatingConversation: boolean;
  isForOverview: boolean;
  onStartConversation: (message?: string) => Promise<{ isSuccess: boolean }>;
  selectedCallerID: string;
  gpxFeature?: GPXFeature;
}

const TF911ChatHeaderButtons = ({
  isFetchingMetadata,
  showStartChat,
  isCreatingConversation,
  isForOverview,
  onStartConversation,
  selectedCallerID,
  gpxFeature,
}: TF911ChatHeaderButtonsProps) => {
  if (isFetchingMetadata) {
    return (
      <Box width="100%" height="100%" pb="16px">
        <Box
          alignSelf="center"
          horizontal
          width="100%"
          borderRadius="0 0 5px 5px"
        >
          <Button
            btnType="tertiary"
            disabled={isFetchingMetadata}
            isLoadingProp={isFetchingMetadata}
            noMargin
            size="med"
            grow
          />
        </Box>
      </Box>
    );
  } else if (showStartChat) {
    return (
      <TF911StartChatAccordion
        isCreatingConversation={isCreatingConversation}
        isForOverview={isForOverview}
        onStartConversation={onStartConversation}
        gpxFeature={gpxFeature}
      />
    );
  } else {
    return (
      <Box horizontal gridColumnGap="8px" width="100%">
        <LiveVideoButtonContainer
          onStartConversation={onStartConversation}
          isForOverview={isForOverview}
        />
        <TF911EndChat
          callerID={selectedCallerID}
          isForOverview={isForOverview}
          gpxFeature={gpxFeature}
        />
      </Box>
    );
  }
};

export default TF911ChatHeaderButtons;
